import { useDispatch, useSelector } from "react-redux";
import { fetchAllOperatorDefaultConfigurations } from "../../slices/OperatorManagement/GetAllDefaultConfiguraions/thunk";
import React, { createRef, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "../Utils/Loader";
import { Button, Col, Input, Nav, NavItem, NavLink, Row } from "reactstrap";
import { customerRetrievalCheck, mapConfigurationsToSwitchState, restructureConfigList } from "./Constant/ConfigFunction";
import { renderField, getDisplayName } from "./Constant/renderField";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import { useNavigate } from "react-router-dom";
import { createOperator } from "../../slices/OperatorManagement/CreateOperator/thunk";
import { editOperator } from "../../slices/OperatorManagement/EditOperator/thunk";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import moment from "moment";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { fetchAllCurrencyCodes } from "../../slices/OperatorManagement/GetCurrencyCodes/thunk";
import { fetchConfigurations } from "../../slices/OperatorManagement/GetConfiguration/thunk";
import { MultiSelectDropdown } from "./Constant/MultiSelectDropdown";

export default function ConfigurationForOperator({
    setFinalValues,
    finalValues,
    values,
    configData,
    isEdit,
    setDefaultConfigurations,
    setFinalTemplates,
    finalTemplates,
    toggleTab,
    operatorId,
    update,
    setUpdate,
    profile,
    logoFile,
    fileSelected,
    editData,
    setFileSelected,
    setEditData,
    defaultConfigurations,
    configFrom = "",
    handleConfirm = () => { },
    isChecked,
}) {
    const [loading, setLoading] = useState(false);
    const [restructuredConfigList, setRestructuredConfigList] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState("");
    const [switchState, setSwitchState] = useState({});
    const [isSSOEnabled, setIsSSOEnabled] = useState(false);
    const [rbac, setRbac] = useState("Native");
    const [intialFilteredValue, setIntialFilteredState] = useState({});
    const [filteredStateValues, setFilteredStateValues] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [quillInstance, setQuillInstance] = useState(null);
    const [inputData, setInputData] = useState({});
    const [shouldConfirm, setShouldConfirm] = useState(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [parentConfigList, setParentConfigList] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = localStorage.getItem("roleName");
    const isCreate = location.pathname.includes("create-operator");
    const sectionRefs = useRef({});
    const emailtemplateRef = useRef();
    const editorRef = useRef(null);
    const isAutoScrolling = useRef(false);
    const rightContentRef = useRef(null);

    useEffect(() => {
        if (values?.Domain) {
            dispatch(fetchAllOperatorDefaultConfigurations(setLoading, values.Domain.label));
        }
    }, [dispatch, values?.Domain]);

    useEffect(() => {
        if (shouldConfirm) {
            handleConfirm();
            setShouldConfirm(false);
        }
    }, [shouldConfirm]);

    const OperatorDefaultConfigurationList = useSelector(
        (state) => state.GetAllDefaultConfiguration.OperatorDefaultConfiguration
    );

    useEffect(() => {
        dispatch(fetchAllCurrencyCodes(setLoading));
        dispatch(fetchConfigurations(setLoading, "exclude_generic_for_domains"));
    }, []);

    useEffect(() => {
        customerRetrievalCheck(
            isCreate,
            setSwitchState,
            values,
        );
    }, [
        isCreate,
        values?.Domain,
        switchState?.CustomerSearch,
        switchState?.CustomerListing,
    ]);


    useEffect(() => {
        setDefaultConfigurations(OperatorDefaultConfigurationList || []);
    }, [OperatorDefaultConfigurationList]);

    const OperatorDefaultConfigurationListFiltered = useMemo(() => {
        const filteredList =
            OperatorDefaultConfigurationList?.filter((config) => config.scope.includes(role) && !(config.name === "notificationManagement" && role === "systemUser")) || [];

        filteredList.forEach((config) => {
            const refName = `${config.name.replace(/\s/g, "").toLowerCase()}Ref`;
            sectionRefs.current[refName] = sectionRefs.current[refName] || createRef();
        });

        setRestructuredConfigList(restructureConfigList(filteredList));
        return filteredList;
    }, [OperatorDefaultConfigurationList, role, values.Domain]);

    const sessionRetentionOptions = [
        { label: "Seconds", value: "second" },
        { label: "Minutes", value: "minute" },
        { label: "Hours", value: "hour" },
        { label: "Days", value: "day" },
        { label: "Weeks", value: "week" },
        { label: "Months", value: "month" },
        { label: "Years", value: "year" },
    ];

    useEffect(() => {
        mapConfigurationsToSwitchState(configData, setSwitchState, OperatorDefaultConfigurationListFiltered, isEdit)
    }, [configData, OperatorDefaultConfigurationListFiltered, isEdit]);

    useEffect(() => {
        if (isEdit && values?.isSSOUser !== undefined) {
            setIsSSOEnabled(values.isSSOUser);
        } else if (editData?.adminOperator?.isSSOUser !== undefined) {
            setIsSSOEnabled(editData.adminOperator.isSSOUser);
        }
    }, [isEdit, values?.isSSOUser, editData?.adminOperator?.isSSOUser]);

    const handleScrollTo = (configName) => {
        const refKey = `${configName.replace(/\s/g, "").toLowerCase()}Ref`;
        const targetRef = configName === "Email Template" ? emailtemplateRef : sectionRefs.current[refKey];
        const container = rightContentRef.current;

        if (targetRef?.current && container) {
            isAutoScrolling.current = true;
            container.scrollTo({
                top: targetRef.current.offsetTop - container.offsetTop,
                behavior: "smooth",
            });
            setTimeout(() => (isAutoScrolling.current = false), 1000);
        }
    };

    const handleRightScroll = () => {
        if (isAutoScrolling.current) return;

        const scrollTop = rightContentRef.current?.scrollTop ?? 0;
        let closest = null;
        let min = Infinity;

        Object.entries(sectionRefs.current).forEach(([key, ref]) => {
            if (!ref.current) return;
            const distance = Math.abs(ref.current.offsetTop - scrollTop);
            if (distance < min) {
                min = distance;
                closest = key === "whatsappmanagementRef" ? "alerts&notifications" : key?.replace("Ref", "");
            }
            if (emailtemplateRef?.current) {
                const distance = Math.abs(emailtemplateRef.current.offsetTop - scrollTop);
                if (distance < min) {
                    closest = "emailtemplate";
                }
            }
        });

        if (closest !== selectedMenu) setSelectedMenu(closest);
    };

    useEffect(() => {
        const initialFilteredValues =
            OperatorDefaultConfigurationListFiltered.filter((entry) =>
                entry?.name?.includes("subscription.engine.templates.")
            ).flatMap((entry) =>
                entry?.value
                    .filter((val) => {
                        const keyName = val?.key?.split(".").pop(); // Extract last part of key
                        return switchState[keyName] === true; // Check if it's true
                    })
                    .map((val) => ({ name: entry.name, value: val.value }))
            );
        setIntialFilteredState(initialFilteredValues);
        // Update the filtered values with configData
        const updatedValues = updateTemplateValues(
            initialFilteredValues,
            configData
        );
        setFilteredStateValues(updatedValues);
    }, [switchState, OperatorDefaultConfigurationListFiltered, configData]);


    useEffect(() => {
        setFinalValues(switchState)
    }, [switchState])

    useEffect(() => {
        if (filteredStateValues && filteredStateValues.length > 0) {
            setFinalTemplates([...filteredStateValues]);
        } else setFinalTemplates([]);
    }, [filteredStateValues]);

    useEffect(() => {
        if (isEdit) {
            if (isSSOEnabled) {
                setRbac(switchState["IdentityProvider.Azure"] ? "Azure" : "Google")
            } else {
                setRbac(switchState["IdentityProvider"])
            }
        }
    }, [isEdit, switchState])

    // function updateTemplateValues(filteredStateValues, configData) {
    //     // If no configData or no configurations, return original filteredStateValues
    //     if (!configData?.configurations || configData.configurations.length === 0) {
    //         return filteredStateValues;
    //     }

    //     // Create a map of configurations from configData for easy lookup
    //     const configMap = configData.configurations.reduce((acc, config) => {
    //         acc[config.name] = config.value[0].value[0];
    //         return acc;
    //     }, {});

    //     // Update filteredStateValues with configData values
    //     const updatedValues = filteredStateValues.map((item) => {
    //         // Check if this template exists in configMap
    //         if (configMap[item.name]) {
    //             // Parse the config value (which is a JSON string)
    //             const parsedConfigValue = JSON.parse(configMap[item.name]);

    //             // Return the updated item with the config value
    //             return {
    //                 ...item,
    //                 value: [JSON.stringify(parsedConfigValue)],
    //             };
    //         }
    //         // If no matching config, return the original item
    //         return item;
    //     });

    //     return updatedValues;
    // }
    function updateTemplateValues(filteredStateValues, configData) {

        if (!configData?.configurations || Object.keys(configData.configurations).length === 0) {
            return filteredStateValues;
        }

        const configMap = {};

        Object.entries(configData.configurations).forEach(([configName, config]) => {
            const valueObject = config?.value || {};

            const parsedValue = {};

            Object.entries(valueObject).forEach(([key, item]) => {
                parsedValue[key] = item?.value;
            });

            configMap[configName] = parsedValue;
        });

        const updatedValues = filteredStateValues.map((item) => {

            if (configMap[item.name]) {

                return {
                    ...item,
                    value: [JSON.stringify(configMap[item.name])]
                };
            }

            return item;
        });

        return updatedValues;
    }

    useEffect(() => {
        if (!editorRef.current || quillInstance) return;

        const quill = new Quill(editorRef.current, {
            theme: "snow",
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ font: [] }],
                    [{ size: [] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ align: [] }],
                    ["direction"],
                    [{ color: [] }, { background: [] }],
                    // ["clean"]
                ],
            },
            readOnly: true,
        });

        setQuillInstance(quill);

        quill.on("text-change", () => {
            setHtmlContent(quill.root.innerHTML);
        });
    }, [filteredStateValues]);

    // 2. When template changes, load content or disable editor
    useEffect(() => {
        if (!quillInstance) return;

        if (selectedTemplate) {
            try {
                const templateData = JSON.parse(selectedTemplate.value[0]);
                setInputData(templateData.inputData || {});
                const fullHtmlContent = templateData.message || "";

                // Clean up content
                let content = fullHtmlContent.replace(
                    /<img[^>]+src=['"]cid:[^'"]+['"][^>]*>/g,
                    ""
                );
                content = content.replace(/{{\.([^}]+)}}/g, "[$1]");

                quillInstance.setContents([]);
                quillInstance.clipboard.dangerouslyPasteHTML(content);
                quillInstance.enable(true); // Make editable
            } catch (err) {
                console.error("Invalid JSON in selectedTemplate:", err);
            }
        } else {
            // No template — disable and clear
            quillInstance.setText("");
            quillInstance.enable(false);
        }
    }, [selectedTemplate, quillInstance]);

    const insertVariable = (variable) => {
        if (quillInstance) {
            const range = quillInstance.getSelection();
            if (range) {
                // Display variable as [variableName] in the editor
                quillInstance.insertText(range.index, `[${variable}]`);
            }
        }
    };

    // const handleSaveTemplate = () => {
    //     if (quillInstance && selectedTemplate) {
    //         // Extract content from Quill editor
    //         let content = quillInstance.root.innerHTML;

    //         // Convert [variable] format back to {{.variable}} format for saving
    //         content = content.replace(/\[([^\]]+)\]/g, "{{.$1}}");

    //         // Ensure image placeholder stays
    //         if (!content.includes("<img")) {
    //             content = `<img src="cid:image1" width="200px">` + content;
    //         }

    //         // Comprehensive inline styling approach
    //         const processedContent = processEmailContent(content);

    //         try {
    //             const templateData = JSON.parse(selectedTemplate.value[0]);

    //             const updatedTemplateData = { ...templateData };
    //             updatedTemplateData.message = processedContent;

    //             const updatedTemplateValue = JSON.stringify(updatedTemplateData);

    //             const updatedTemplate = {
    //                 name: selectedTemplate.name,
    //                 value: updatedTemplateValue,
    //             };

    //             const updatedTemplates = finalTemplates.map((template) =>
    //                 template.name === selectedTemplate.name ? updatedTemplate : template
    //             );

    //             setFinalTemplates(updatedTemplates);

    //             if (typeof setFilteredStateValues === "function") {
    //                 setFilteredStateValues(updatedTemplates);
    //             }

    //             // setIsEditTemplateSliderOpen(false);

    //             return updatedTemplate;
    //         } catch (error) {
    //             console.error("Error updating template JSON:", error);
    //             return null;
    //         }
    //     }
    //     return null;
    // };

    const handleSaveTemplate = () => {

        if (!quillInstance || !selectedTemplate) return null;

        // Extract content from Quill editor
        let content = quillInstance.root.innerHTML;

        // Convert [variable] → {{.variable}}
        content = content.replace(/\[([^\]]+)\]/g, "{{.$1}}");

        // Ensure image placeholder stays
        if (!/<img/i.test(content)) {
            content = `<img src="cid:image1" width="200px">` + content;
        }

        const processedContent = processEmailContent(content);
        
        try {

            const templateData = JSON.parse(selectedTemplate?.value || "{}");

            const updatedTemplateData = {
                ...templateData,
                message: processedContent
            };

            const updatedTemplateValue = JSON.stringify(updatedTemplateData);

            const updatedTemplate = {
                name: selectedTemplate.name,
                value: updatedTemplateValue
            };

            const updatedTemplates = finalTemplates.map((template) =>
                template.name === selectedTemplate.name
                    ? updatedTemplate
                    : template
            );
            setFinalTemplates(updatedTemplates);

            if (typeof setFilteredStateValues === "function") {
                setFilteredStateValues(updatedTemplates);
            }

            return updatedTemplate;

        } catch (error) {

            console.error("Error updating template JSON:", error);
            return null;

        }
    };
    const processEmailContent = (content) => {
        // Create a temporary div to manipulate the content
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;

        // More comprehensive font and styling mapping
        const fontClasses = {
            "ql-font-serif": { fontFamily: 'Georgia, "Times New Roman", serif' },
            "ql-font-monospace": { fontFamily: 'Courier, "Courier New", monospace' },
            "ql-font-sans-serif": { fontFamily: "Arial, Helvetica, sans-serif" },
        };

        // Expanded size classes with more granular mapping
        const sizeClasses = {
            "ql-size-small": { fontSize: "0.75em" },
            "ql-size-large": { fontSize: "1.5em" },
            "ql-size-huge": { fontSize: "2.5em" },
        };

        // Comprehensive style mapping
        const styleMapping = {
            ...fontClasses,
            ...sizeClasses,
            "ql-align-center": { textAlign: "center" },
            "ql-align-right": { textAlign: "right" },
            "ql-align-left": { textAlign: "left" },
            "ql-align-justify": { textAlign: "justify" },
        };

        // Recursive processing function
        const processElement = (element) => {
            // Preserve original classes for potential future reference
            const originalClasses = Array.from(element.classList);

            // Apply styles based on classes
            originalClasses.forEach((className) => {
                if (styleMapping[className]) {
                    Object.entries(styleMapping[className]).forEach(([prop, value]) => {
                        element.style[prop] = value;
                    });
                    // Optionally, keep the original class for reference
                    element.dataset.originalClass = className;
                }
            });

            // Process child elements
            Array.from(element.children).forEach(processElement);
        };

        // Process the entire content
        processElement(tempDiv);

        // Wrap in a styled container
        const emailWrapper = `
        <div style="
            max-width: 400px; 
            background-color: white; 
            margin: 0 auto; 
            border-radius: 8px; 
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); 
            padding: 20px; 
            border: solid; 
            border-color: #0078A3; 
            border-radius: 12px;
            font-family: Arial, Helvetica, sans-serif;
        ">
            ${tempDiv.innerHTML}
        </div>
        `;

        return emailWrapper;
    };

    useEffect(() => {
        if (filteredStateValues && filteredStateValues.length > 0) {
            setFinalTemplates([...filteredStateValues]);
        } else setFinalTemplates([]);
    }, [filteredStateValues]);

    useEffect(() => {
        if (!restructuredConfigList?.length) return;

        const newParentConfigs = [];
        let firstParentMenu = null;

        restructuredConfigList.forEach((category, catIndex) => {
            category?.configList?.forEach((configuration, confIndex) => {

                if (isParentConfiguration(configuration) && !newParentConfigs.find(i => i.name === configuration.name)) {
                    newParentConfigs.push(configuration);

                    // If no selected menu yet, set the first one
                    if (!firstParentMenu && catIndex === 0 && confIndex === 0) {
                        firstParentMenu = configuration.name
                            ?.split(" ")
                            ?.join("")
                            ?.toLowerCase();
                    }
                }
            });
        });

        setParentConfigList(newParentConfigs);

        if (!selectedMenu && firstParentMenu) {
            setSelectedMenu(firstParentMenu);
        }
    }, [restructuredConfigList, switchState]);

    const handleParentSwitchToggle = (key) => {
        setSwitchState(prev => {
            const newState = { ...prev };
            const newValue = !prev[key];
            newState[key] = newValue;
            if (!newValue) {
                parentConfigList?.forEach(parentConfig => {
                    parentConfig.value?.forEach(item => {
                        if (item.key.startsWith(key + ".")) {
                            newState[item.key] = false;
                        }
                    });
                });
            }
            return newState;
        });
    };

    const currencies = useSelector(
        (state) => state.GetAllCurrency.GetAllCurrency
    );

    const currencyCodes = currencies?.map((currency) => ({
        label: currency.currencyCode,
        value: currency.currencyCode,
    }));

    const nonGenericConfig = useSelector((state) => state.GetConfiguration.Configuration);
    const isNonGeneric = useMemo(() => {
        if (!nonGenericConfig?.value?.[0]?.value || !values?.Domain?.label) return false;
        return nonGenericConfig.value[0].value.includes(values.Domain.label);
    }, [nonGenericConfig, values?.Domain?.label]);

    // const isCustomConfig = (config) => {
    //     if (config?.name?.includes("subscription.engine.templates")) return false;
    //     if (config?.category === "Alerts & Notifications") return true;

    //     if (!Array.isArray(config.value)) return false;
    //     const fields = config.value;

    //     // Single toggle
    //     if (fields.length === 1 && fields[0].widget === "toggle") return false;

    //     // Multiple toggles only
    //     const allToggle = fields.every(
    //         (f) => f.widget === "toggle" && Array.isArray(f.value) && f.value.includes("True")
    //     );
    //     if (allToggle) return false;
    //     return true;
    // };

    const isCustomConfig = (config) => {
        if (!config) return false;
        if (config?.name?.includes("subscription.engine.templates")) return false;
        if (config?.category === "Alerts & Notifications") return true;

        if (!config.value || typeof config.value !== "object") return false;

        const fields = Object.values(config.value);

        // Single toggle
        if (fields.length === 1 && fields[0].widget === "toggle") return false;

        // Multiple toggles only
        const allToggle = fields.every(
            (f) => f.widget === "toggle" && f.value === true || f.value === "True"
        );

        if (allToggle) return false;

        return true;
    };

    useEffect(() => {
        if (!restructuredConfigList?.length) return;
        const newCustomConfigs = [];
        let firstCustomMenu = null;

        restructuredConfigList.forEach((category, catIndex) => {
            category?.configList?.forEach((configuration, confIndex) => {
                if (isCustomConfig(configuration) && !newCustomConfigs.find(i => i.name === configuration.name)) {
                    newCustomConfigs.push(configuration);

                    // If no selected menu yet, set the first one
                    if (!firstCustomMenu && catIndex === 0 && confIndex === 0) {
                        firstCustomMenu = configuration.name
                            ?.split(" ")
                            ?.join("")
                            ?.toLowerCase();
                    }
                }
            });
        });
        if (!selectedMenu && firstCustomMenu) {
            setSelectedMenu(firstCustomMenu);
        }
    }, [restructuredConfigList, switchState]);

    const formatTemplateName = (name) => {
        return name.replace(/([A-Z])/g, " $1").trim();
    };

    const isParentConfiguration = (config) => {
        if (config.name === "identityManagement" || !config || !config.value || !Array.isArray(config.value)) {
            return false;
        }

        // A parent configuration should have at least 2 items (parent + at least one child)
        if (config.value.length < 2) {
            return false;
        }

        const keys = config.value.map(item => item.key);
        const parentKey = keys[0];

        // Check if there are child keys that follow the parent.child pattern
        const hasChildKeys = keys.some((key, index) => {
            if (index === 0) return false; // Skip the parent key itself
            return key.startsWith(parentKey + '.');
        });

        return hasChildKeys;
    }

    const isAllToggle = (config) =>
        Array.isArray(config.value) && config.value.length > 0 && config.value.every((f) => f.widget?.toLowerCase() === "toggle");

    return (
        <div>
            {loading && <Loader />}
            <Row className="pb-0 px-4 me-2">
                <Col xxl={3} lg={4} md={12} className="pe-0 pt-3">
                    <div className="sidebar">
                        <div className="navbar-conf">
                            <nav className="nav-conf pe-4">
                                <div className="container-fluid">
                                    <Nav navbar>
                                        {restructuredConfigList.map((category, idx) => (
                                            <NavItem key={idx}>
                                                {category?.categoryName && (
                                                    <NavLink
                                                        className={`fs-14 fw-semibold p-1 ${category?.categoryName ===
                                                            "Alerts & Notifications" &&
                                                            role === "systemUser"
                                                            ? "nav-items"
                                                            : ""
                                                            } ${selectedMenu ===
                                                                category.categoryName
                                                                    ?.split(" ")
                                                                    ?.join("")
                                                                    ?.toLowerCase()
                                                                ? "nav-item active rv-text-primary-color"
                                                                : "nav-item  rv-text-color"
                                                            }`}
                                                        onClick={() =>
                                                            category?.categoryName ===
                                                            "Alerts & Notifications" &&
                                                            role === "systemUser" &&
                                                            (setSelectedMenu(
                                                                category?.categoryName
                                                                    ?.split(" ")
                                                                    ?.join("")
                                                                    ?.toLowerCase()
                                                            ),
                                                                handleScrollTo(category?.configList[0]?.name))
                                                        }
                                                    >
                                                        <span
                                                            className={
                                                                selectedMenu ===
                                                                    category.categoryName
                                                                        ?.split(" ")
                                                                        ?.join("")
                                                                        ?.toLowerCase()
                                                                    ? "rv-text-primary-color"
                                                                    : "rv-text-color"
                                                            }
                                                        >
                                                            {category?.categoryName}
                                                        </span>
                                                    </NavLink>
                                                )}
                                                {category.configList.map((config, cIdx) => {
                                                    if ((category?.categoryName === "Alerts & Notifications" && role === "systemUser") || config.name === "SessionExpiryTime" || (config.name === "Rated Event Consumer Configuration" && (!switchState["Mode"] || switchState["Mode"] === "None")) || config.name.includes("subscription.engine.templates")) return null;

                                                    const fields = config.value;
                                                    const parentId = config.name.replace(/\s/g, "").toLowerCase();
                                                    if (category?.categoryName ===
                                                        "Alerts & Notifications" &&
                                                        role !== "systemUser") {
                                                        return (
                                                            <>
                                                                <NavLink
                                                                    className={`nav-items fs-14 fw-semibold p-1 ${selectedMenu ===
                                                                        config.name
                                                                            ?.split(" ")
                                                                            ?.join("")
                                                                            ?.toLowerCase()
                                                                        ? "nav-item active rv-text-primary-color"
                                                                        : "nav-item"
                                                                        }`}
                                                                    onClick={() => {
                                                                        setSelectedMenu(
                                                                            config.name
                                                                                ?.split(" ")
                                                                                ?.join("")
                                                                                ?.toLowerCase()
                                                                        );
                                                                        handleScrollTo(config.name);
                                                                    }}
                                                                >
                                                                    -{" "}
                                                                    <span className="mx-1">
                                                                        {getDisplayName(config.name)}
                                                                    </span>
                                                                </NavLink>
                                                                <NavLink
                                                                    className={`nav-items fs-14 fw-semibold p-1 ${selectedMenu ===
                                                                        "Email Template"
                                                                            .split(" ")
                                                                            ?.join("")
                                                                            ?.toLowerCase()
                                                                        ? "nav-item active rv-text-primary-color"
                                                                        : "nav-item"
                                                                        }`}
                                                                    onClick={() => {
                                                                        setSelectedMenu(
                                                                            "Email Template"
                                                                                .split(" ")
                                                                                ?.join("")
                                                                                ?.toLowerCase()
                                                                        );
                                                                        handleScrollTo("Email Template");
                                                                    }}
                                                                >
                                                                    -{" "}
                                                                    <span className="mx-1">
                                                                        {"Email Template"}
                                                                    </span>
                                                                </NavLink>
                                                            </>
                                                        )
                                                    }
                                                    if (isParentConfiguration(config)) {
                                                        return (
                                                            <NavLink
                                                                className={`nav-items fs-14 fw-semibold p-1 d-flex align-items-center w-100 ${selectedMenu === config?.name?.split(" ")?.join("")?.toLowerCase()
                                                                    ? "nav-item active rv-text-primary-color"
                                                                    : "nav-item"
                                                                    }`}
                                                                onClick={() => {
                                                                    setSelectedMenu(config?.name?.split(" ")?.join("")?.toLowerCase());
                                                                    handleScrollTo(config.name);
                                                                }}
                                                            >
                                                                <span className="flex-grow-1 text-wrap me-2">
                                                                    -{" "}
                                                                    {getDisplayName(config.name)}
                                                                </span>
                                                                <span className="form-switch flex-shrink-0 d-flex align-items-center ms-auto">
                                                                    <Input
                                                                        type="switch"
                                                                        className="rv-form-switch-input"
                                                                        checked={switchState[config.name] || false}
                                                                        onChange={() => {
                                                                            handleParentSwitchToggle(config.name);
                                                                        }}
                                                                    />
                                                                </span>
                                                            </NavLink>
                                                        )
                                                    }
                                                    if (isAllToggle(config)) {
                                                        return fields.map((f, fIdx) => {
                                                            if (
                                                                f.key !== "PaymentEnabled" &&
                                                                f.key !== "Generate CSV File" &&
                                                                f.key !== "Trigger One Bill API"
                                                            ) {
                                                                const key = f.key;
                                                                const disabled =
                                                                    key === "BRMTaskEnabled" &&
                                                                    !switchState["TaskEnabled"];

                                                                return (
                                                                    <NavLink
                                                                        key={fIdx}
                                                                        className={`nav-items fs-14 fw-semibold p-1 d-flex align-items-center w-100 ${selectedMenu === key.toLowerCase()
                                                                            ? "nav-item active rv-text-primary-color"
                                                                            : "nav-item"
                                                                            }`}
                                                                        onClick={() => {
                                                                            if (!disabled) {
                                                                                setSelectedMenu(key.toLowerCase());
                                                                                handleScrollTo(config.name);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <span className="flex-grow-1 text-wrap me-2">
                                                                            - {config.name === "EIP" ? "EIP" : getDisplayName(key)}
                                                                        </span>
                                                                        <span className="form-switch ms-auto">
                                                                            <Input
                                                                                type="switch"
                                                                                disabled={disabled}
                                                                                className="rv-form-switch-input"
                                                                                checked={config.name === "EIP" ? !!switchState["EIP"] : !!switchState[key]}
                                                                                onChange={() => {
                                                                                    if (config.name === "EIP") {
                                                                                        setSwitchState(prev => ({
                                                                                            ...prev,
                                                                                            ["EIP"]: !prev["EIP"],
                                                                                        }));
                                                                                    } else if (!disabled) {
                                                                                        setSwitchState(prev => {
                                                                                            const updated = {
                                                                                                ...prev,
                                                                                                [key]: !prev[key],
                                                                                            };
                                                                                            if (key === "TaskEnabled" && !updated.TaskEnabled) {
                                                                                                updated.BRMTaskEnabled = false;
                                                                                            }
                                                                                            return updated;
                                                                                        });

                                                                                    }
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </NavLink>
                                                                );
                                                            }
                                                        });
                                                    }
                                                    if (isCustomConfig(config)) {
                                                        return (
                                                            <NavLink
                                                                key={cIdx}
                                                                className={`nav-items fs-14 fw-semibold p-1 ${selectedMenu === parentId ? "nav-item active rv-text-primary-color" : "nav-item"
                                                                    }`}
                                                                onClick={() => {
                                                                    setSelectedMenu(parentId);
                                                                    handleScrollTo(config.name);
                                                                }}
                                                            >
                                                                {config.name ===
                                                                    "DefaultCurrency" ? (
                                                                    <span className="mx-1">
                                                                        {getDisplayName(config.name)}
                                                                    </span>
                                                                ) : (
                                                                    <span className="mx-1">
                                                                        -{" "}
                                                                        {getDisplayName(config.name)}
                                                                    </span>
                                                                )}
                                                            </NavLink>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                                <hr className="p-1 m-0" />
                                            </NavItem>
                                        ))}
                                    </Nav>
                                </div>
                            </nav>
                        </div>
                    </div>
                </Col>
                <Col xxl={9} lg={8} md={12} className="pt-2 pb-0">
                    <Row>
                        <div
                            className={
                                configFrom === "createConfig"
                                    ? "custom-config-create"
                                    : "custom-config"
                            }
                            ref={rightContentRef}
                            onScroll={handleRightScroll}
                        >
                            {restructuredConfigList.map((category, idx) => (
                                <div key={idx}>
                                    {category.configList.map((config) => {
                                        if (!isCustomConfig(config) && !isParentConfiguration(config)) return null;
                                        if (config.name === "Rated Event Consumer Configuration" && (!switchState["Mode"] || switchState["Mode"] === "None") || config.name === "SessionExpiryTime") return null;

                                        const id = config.name.replace(/\s/g, "").toLowerCase();
                                        const isCustomerRetrieval = config.name === "CustomerRetrieval";
                                        const isWhatsapp = config.name === "whatsAppManagement"
                                        const isSessionExpiry = config.name === "SessionExpiryBuffer"

                                        if (isParentConfiguration(config)) {
                                            const keyName = config?.name?.split(" ").join("").toLowerCase();
                                            const configRef = sectionRefs.current[keyName + "Ref"];
                                            const isParentEnabled = switchState[config.name] || false;
                                            const findSubChildren = (childKey) => {

                                                const parentDepth = childKey.split(".").length;

                                                return (
                                                    config?.value?.filter((item) => {
                                                        const isDirectDescendant = item.key.startsWith(childKey + ".");

                                                        if (!isDirectDescendant) return false;
                                                        const childDepth = item.key.split(".").length;
                                                        const isOneLevelDeeper = childDepth === parentDepth + 1;
                                                        return isOneLevelDeeper;
                                                    }) || []
                                                );
                                            };
                                            return (
                                                <React.Fragment key={idx}>
                                                    <div
                                                        className={`rounded-1 px-4 py-3 my-2 ${selectedMenu === keyName ? "rv-shadow-subtle" : "border"
                                                            } ${!isParentEnabled ? "opacity-50" : ""}`}
                                                        ref={configRef}
                                                    >
                                                        <Row>
                                                            <LabelText
                                                                displayText={getDisplayName(config.name)}
                                                                classLabelName={`rv-text-color conf-header pb-3 form-label${!isParentEnabled ? "text-muted" : ""}`}
                                                            />
                                                            {config?.value?.map((child, childIdx) => {
                                                                const keyDepth = (child.key.match(/\./g) || []).length;

                                                                if (
                                                                    child.key === config.name ||
                                                                    child.key === "PaymentEnabled" ||
                                                                    child.key === "Generate CSV File" ||
                                                                    child.key === "Trigger One Bill API" ||
                                                                    keyDepth > 1 // Skip sub-children (they have 2+ dots)
                                                                ) {
                                                                    return null;
                                                                }
                                                                if (keyDepth === 0 && child.key !== config.name) {
                                                                    return null;
                                                                }
                                                                const isChildEnabled = switchState[child.key] || false;
                                                                const subChildren = config?.value?.length > 0 ? findSubChildren(child.key) : [];

                                                                const childDisplayName = child.key.includes(".")
                                                                    ? child.key.split(".").pop().replace(/([A-Z])/g, " $1").trim()
                                                                    : child.key.replace(/([A-Z])/g, " $1").trim();

                                                                return (
                                                                    <React.Fragment key={childIdx}>
                                                                        <Col lg={6} md={8} className="mb-3">
                                                                            <div className="d-flex flex-column">
                                                                                {/* Child toggle */}
                                                                                <div className="d-flex justify-content-between gap-1 mb-2">
                                                                                    <LabelText
                                                                                        displayText={childDisplayName}
                                                                                        classLabelName={`rv-text-color form-label ${!isParentEnabled ? "text-muted" : ""}`}
                                                                                    />
                                                                                    <span className="form-switch flex-shrink-0 d-flex align-items-center">
                                                                                        <Input
                                                                                            type="switch"
                                                                                            className="rv-form-switch-input"
                                                                                            checked={isChildEnabled}
                                                                                            disabled={!isParentEnabled}
                                                                                            onChange={() => {
                                                                                                if (isParentEnabled) {
                                                                                                    handleParentSwitchToggle(child.key);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                </div>

                                                                                {isChildEnabled && isParentEnabled && subChildren.length > 0 && (
                                                                                    <div className="ps-3">
                                                                                        {subChildren.length === 1 ? (
                                                                                            // Single sub-child: Show as toggle inline
                                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                                <LabelText
                                                                                                    displayText={
                                                                                                        // getDisplayName(subChildren[0].key)
                                                                                                        // configDisplayNameMapping[subChildren[0].key] ||
                                                                                                        subChildren[0].key.split(".").pop().replace(/([A-Z])/g, " $1").trim()
                                                                                                    }
                                                                                                    classLabelName="rv-text-color form-label text-muted fs-14"
                                                                                                />
                                                                                                <span className="form-switch flex-shrink-0 d-flex align-items-center">
                                                                                                    <Input
                                                                                                        type="switch"
                                                                                                        className="rv-form-switch-input"
                                                                                                        checked={switchState[subChildren[0].key] || false}
                                                                                                        onChange={() => {
                                                                                                            handleParentSwitchToggle(subChildren[0].key)
                                                                                                        }}
                                                                                                    />
                                                                                                </span>
                                                                                            </div>
                                                                                        ) : (
                                                                                            // Multiple sub-children: Show as multi-select dropdown with checkboxes
                                                                                            <MultiSelectDropdown
                                                                                                childKey={child.key}
                                                                                                subChildren={subChildren}
                                                                                                switchState={switchState}
                                                                                                getDisplayName={getDisplayName}
                                                                                                handleParentSwitchToggle={handleParentSwitchToggle}
                                                                                                setSwitchState={setSwitchState}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </Col>
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </Row>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        }
                                        if ((config?.name === "notificationManagement" || config?.name === "NotificationManagement") && role !== "systemUser") {
                                            return (
                                                <>
                                                    <div
                                                        className={`rounded-1 px-4 py-3 my-2 ${selectedMenu === config?.name?.split(" ").join("").toLowerCase()
                                                            ? "rv-shadow-subtle"
                                                            : "border"
                                                            }`}
                                                        ref={sectionRefs.current[config?.name?.split(" ").join("").toLowerCase() + "Ref"]}
                                                    >
                                                        <Row>
                                                            <LabelText
                                                                displayText="Notifications"
                                                                classLabelName={"conf-header fs-16 pb-3"}
                                                            />
                                                            <Row className="ms-1">
                                                                {config?.value
                                                                    ?.filter((item) => item.key !== "NotificationEnable")
                                                                    .map((item, idx) => (
                                                                        <Col xxl={4} lg={6} md={6} className="mb-2 mt-1" key={idx}>
                                                                            <div className="form-switch d-flex align-items-start flex-nowrap">
                                                                                <Input
                                                                                    type="switch"
                                                                                    className="rv-form-switch-input me-2 flex-shrink-0"
                                                                                    checked={switchState[item.key] || false}
                                                                                    onChange={() =>
                                                                                        setSwitchState(prev => ({
                                                                                            ...prev,
                                                                                            [item.key]: !prev[item.key],
                                                                                        }))
                                                                                    }
                                                                                />
                                                                                <LabelText
                                                                                    displayText={getDisplayName(item.key)}
                                                                                    className="conf-header mb-0"
                                                                                    classLabelName="rv-text-color"
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    ))}
                                                            </Row>
                                                        </Row>
                                                    </div>

                                                    {filteredStateValues && filteredStateValues.length > 0 && (
                                                        <div
                                                            className={`rounded-1 px-4 py-3 my-2 ${selectedMenu === "emailtemplate"
                                                                ? "rv-shadow-subtle"
                                                                : "border"
                                                                }`}
                                                            ref={emailtemplateRef}
                                                        >
                                                            <Row>
                                                                <LabelText
                                                                    displayText="Email Template"
                                                                    classLabelName={"conf-header fs-16 pb-3"}
                                                                />
                                                            </Row>
                                                            <Row>
                                                                <Col lg={12}>
                                                                    <div className="row">
                                                                        {finalTemplates?.map((template, index) => {
                                                                            const rawName = template?.name.split(".").pop();
                                                                            const displayName = formatTemplateName(rawName);
                                                                            return (
                                                                                <div
                                                                                    key={index}
                                                                                    className="col-xxl-4 col-lg-6 col-md-6 mb-2 mt-1 d-flex align-items-start"
                                                                                    onClick={() => {
                                                                                        handleSaveTemplate();
                                                                                        setSelectedTemplate(template);
                                                                                    }}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    <i className={`fs-4 me-3 ri-edit-2-line ${selectedTemplate === template ? "rv-text-primary-color" : ""}`} />
                                                                                    <LabelText
                                                                                        displayText={displayName}
                                                                                        className="flex-grow-1 mb-1 text-wrap"
                                                                                        classLabelName="rv-text-color"
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={12}>
                                                                    <div className="">
                                                                        {/* Available Variables */}
                                                                        {inputData &&
                                                                            Object.keys(inputData)?.length > 0 && (
                                                                                <div
                                                                                    className="d-flex flex-wrap border-1 p-2 mb-0"
                                                                                    style={{
                                                                                        border: "1px solid lightgray",
                                                                                        borderBottom: "none",
                                                                                    }}
                                                                                >
                                                                                    {Object.keys(inputData)
                                                                                        .filter((key) => {
                                                                                            // Exclude keys related to attachments and images
                                                                                            const excludedPatterns = [
                                                                                                /attachment/i,
                                                                                                /inline_?image/i,
                                                                                                /^image/i,
                                                                                                /file/i,
                                                                                                /^images/i,
                                                                                                /^img/i,
                                                                                                /^doc/i,
                                                                                                /^media/i,
                                                                                            ];

                                                                                            return !excludedPatterns.some(
                                                                                                (pattern) => pattern.test(key)
                                                                                            );
                                                                                        })
                                                                                        .map((key) => {
                                                                                            // Convert camelCase or snake_case to Title Case
                                                                                            const displayName = key
                                                                                                .replace(/([A-Z])/g, " $1") // Add space before capital letters
                                                                                                .replace(/_/g, " ") // Replace underscores with spaces
                                                                                                .replace(/\b\w/g, (char) =>
                                                                                                    char.toUpperCase()
                                                                                                ); // Capitalize first letter of each word
                                                                                            return (
                                                                                                <Button
                                                                                                    key={key}
                                                                                                    size="md"
                                                                                                    className="m-1 email-button px-2 py-1 border-dark"
                                                                                                    onClick={() =>
                                                                                                        insertVariable(key)
                                                                                                    }
                                                                                                >
                                                                                                    {displayName}
                                                                                                </Button>
                                                                                            );
                                                                                        })}
                                                                                </div>
                                                                            )}

                                                                        {/* Quill Editor - Important: We're using a div with a fixed ID for direct manipulation */}
                                                                        <div className="snow-editor mt-0">
                                                                            <div
                                                                                // id="quill-editor"
                                                                                ref={editorRef}
                                                                                style={{ height: "300px" }}
                                                                            ></div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    )}
                                                </>
                                            )
                                        }
                                        return (
                                            <div
                                                key={id}
                                                ref={sectionRefs.current[`${id}Ref`]}
                                                className={config.name === "whatsAppManagement"
                                                    ? `rounded-1 px-4 py-3 my-2 ${selectedMenu === "alerts&notifications" ? "rv-shadow-subtle" : "border"}`
                                                    : `rounded-1 px-4 py-3 my-2 ${selectedMenu === id ? "rv-shadow-subtle" : "border"}`
                                                }
                                            >
                                                {!isWhatsapp && <LabelText
                                                    displayText={
                                                        isCustomerRetrieval
                                                            ? "Customer Retrieval"
                                                            : config.name === "paymentManagement"
                                                                ? getDisplayName(config.value[0].key)
                                                                : getDisplayName(config.name)
                                                    }
                                                    classLabelName="conf-header fs-16 pb-3"
                                                />}
                                                {/* SPECIAL CASE: Whatsapp Management */}
                                                {isWhatsapp ? (
                                                    <Row>
                                                        <LabelText
                                                            displayText="Alerts & Notifications"
                                                            classLabelName={"conf-header fs-16 pb-3"}
                                                        />
                                                        {config?.value.map((val, idx) => (
                                                            <Col
                                                                xxl={4}
                                                                lg={6}
                                                                md={8}
                                                                className="form-switch ms-3"
                                                                key={idx}
                                                            >
                                                                <Input
                                                                    type="switch"
                                                                    className="rv-form-switch-input me-3"
                                                                    checked={!!switchState?.[val?.key]}
                                                                    onChange={() =>
                                                                        setSwitchState(prev => ({
                                                                            ...prev,
                                                                            [val?.key]: !prev[val?.key],
                                                                        }))
                                                                    }
                                                                />
                                                                <LabelText
                                                                    displayText={getDisplayName(val?.key)}
                                                                    className="conf-header me-5"
                                                                    classLabelName={"rv-text-color"}
                                                                />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                ) : isCustomerRetrieval ? (
                                                    <Row>
                                                        {config.value.map((item, idx) => (
                                                            <Col key={idx} lg={6} md={8} className="mb-2">
                                                                <Input
                                                                    type="radio"
                                                                    name="customerRetrieval"
                                                                    className="me-2"
                                                                    checked={switchState?.[item.key]}
                                                                    onChange={() =>
                                                                        setSwitchState((prevState) => {
                                                                            const newState = { ...prevState, [item.key]: !prevState[item.key] };
                                                                            if (item.key === "CustomerSearch" && newState[item.key]) {
                                                                                newState["CustomerListing"] = false;
                                                                            } else if (item.key === "CustomerListing" && newState[item.key]) {
                                                                                newState["CustomerSearch"] = false;
                                                                            } else if (item.key === "CustomerSearch" && !newState[item.key]) {
                                                                                newState["CustomerListing"] = true;
                                                                            } else if (item.key === "CustomerListing" && !newState[item.key]) {
                                                                                newState["CustomerSearch"] = true;
                                                                            }
                                                                            return newState;
                                                                        })
                                                                    }
                                                                />
                                                                <LabelText displayText={getDisplayName(item.key)} classLabelName={"rv-text-color"} />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                ) : isSessionExpiry ? (
                                                    <React.Fragment>
                                                        <Row>
                                                            <Col xxl={4} lg={6} md={12}>
                                                                <LabelText
                                                                    displayText={
                                                                        getDisplayName(config.value[0]?.key)
                                                                    }
                                                                    className="conf-header me-5"
                                                                    classLabelName={"rv-text-color"}
                                                                />
                                                                <p className="text-muted mt-0">
                                                                    Enter Unit (No of Sessions)
                                                                </p>
                                                                <Input
                                                                    type="text"
                                                                    className="mb-3 mt-0"
                                                                    value={switchState[config.value[0]?.key]}
                                                                    onChange={(e) =>
                                                                        setSwitchState(prev => ({
                                                                            ...prev,
                                                                            [config.value[0]?.key]: e.target.value
                                                                        }))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4} md={12}>
                                                                <LabelText
                                                                    displayText={"Session Expiry Time"}
                                                                    className="conf-header me-5"
                                                                    classLabelName={"rv-text-color"}
                                                                />
                                                                <p className="text-muted mt-0">Enter Unit</p>
                                                                <Input
                                                                    type="text"
                                                                    className="mb-3 mt-0"
                                                                    value={switchState["SessionExpiryValue"]}
                                                                    onChange={(e) =>
                                                                        setSwitchState(prev => ({
                                                                            ...prev,
                                                                            "SessionExpiryValue": e.target.value
                                                                        }))
                                                                    }
                                                                />
                                                            </Col>
                                                            <Col lg={4} md={12}>
                                                                <LabelText
                                                                    displayText={" "}
                                                                    className="conf-header me-5"
                                                                    classLabelName={"rv-text-color"}
                                                                />
                                                                <p className="text-muted mt-0">
                                                                    Select Time Period
                                                                </p>
                                                                <SelectField
                                                                    name={`SessionExpiryType`}
                                                                    value={
                                                                        sessionRetentionOptions?.find(
                                                                            (option) =>
                                                                                option.value ===
                                                                                switchState["SessionExpiryType"]
                                                                        ) || switchState["SessionExpiryType"]
                                                                    }
                                                                    handleChange={(selectedOption) =>
                                                                        setSwitchState(prev => ({
                                                                            ...prev,
                                                                            ["SessionExpiryType"]: selectedOption?.value,
                                                                        }))
                                                                    }
                                                                    options={sessionRetentionOptions}
                                                                    isRVStyle={true}
                                                                    placeholder={""}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </React.Fragment>
                                                ) : (
                                                    <Row>
                                                        {config.value.length > 1 && (config.name !== "Prefixes" && config.name !== "SequenceHandling" && config.name !== "identityManagement") && (config.value[0].widget !== "checkbox" && config.value[0].widget !== "radio") &&
                                                            <LabelText
                                                                displayText={config.name === "ML Chatbot history" ? getDisplayName(config?.value[0]?.key) : getDisplayName(config.name)}
                                                                className="conf-header me-5"
                                                                classLabelName={"rv-text-color"}
                                                            />
                                                        }
                                                        {config.value.map((field, idx) => (
                                                            <React.Fragment key={idx}>
                                                                {renderField(
                                                                    field,
                                                                    finalValues,
                                                                    setFinalValues,
                                                                    switchState,
                                                                    setSwitchState,
                                                                    isEdit,
                                                                    isSSOEnabled,
                                                                    setIsSSOEnabled,
                                                                    config,
                                                                    currencyCodes,
                                                                    config.value.length < 2,
                                                                    values?.Domain,
                                                                    rbac,
                                                                    setRbac
                                                                )}
                                                            </React.Fragment>
                                                        ))}
                                                    </Row>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </Row>
                    <Row lg={6} className="d-flex justify-content-end pt-3">
                        <div className="live-preview">
                            {configFrom === "createConfig" ? (
                                <div className="d-flex justify-content-end gap-2">
                                    <Button
                                        className={
                                            "btn-label rv-primary-btn rounded-1 ps-5 pe-3 py-1 fw-bold"
                                        }
                                        onClick={() => {
                                            handleSaveTemplate();
                                            setShouldConfirm(true);
                                        }}
                                    >
                                        <i className="ri-save-line label-icon align-middle fs-16 me-1"></i>
                                        <span>Save</span>
                                    </Button>
                                </div>
                            ) : (
                                <div className="d-flex justify-content-end gap-2">
                                    <Button
                                        className={
                                            "btn-label rv-secondary-btn rounded-1 ps-5 pe-3 py-1 fw-bold"
                                        }
                                        outline="true"
                                        onClick={() => {
                                            toggleTab(1, 0);
                                        }}
                                    >
                                        <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-1"></i>
                                        Cancel{" "}
                                    </Button>
                                    <Button
                                        className={
                                            "btn-label rv-primary-btn rounded-1 ps-5 pe-3 py-1 fw-bold"
                                        }
                                        onClick={() => {
                                            // if (
                                            //     values?.firstname !== "" && values?.lastname !== "" && values?.email !== "" && values?.username !== "" && values?.phone !== ""
                                            // ) {
                                            // handleSave();
                                            const phoneNumber = formatPhoneNumberIntl(values?.phone);
                                            let dialCodeWithPlus =
                                                phoneNumber.match(/^\+\d+(\s|$)/)[0];
                                            let restOfNumber = phoneNumber.slice(
                                                dialCodeWithPlus?.length
                                            );
                                            let mobileNumberWithoutSpaces = restOfNumber.replace(
                                                /\s/g,
                                                ""
                                            );
                                            let dialCodeWithoutSpaces = dialCodeWithPlus.replace(
                                                /\s/g,
                                                ""
                                            );
                                            const convertedEndDateTime = moment(values.endDate)
                                                .endOf("day")
                                                .format();
                                            const appendedZ = moment(convertedEndDateTime)
                                                .utc()
                                                .set({ hour: 23, minute: 59, second: 59 })
                                                .format();
                                            const formattedValues = {
                                                tradingName: values.businessName,
                                                existsDuring: {
                                                    endDateTime: appendedZ,
                                                    // startDateTime: "2023-01-01T00:00:00Z"
                                                },
                                                domain: values?.Domain?.value === "SGCAdmin" ? values?.Role?.value : values.Domain?.value,
                                                state: values.state?.value,
                                                city: values.city?.value,
                                                country: values.country?.value,
                                                postcode: values.zipCode.toString(),
                                                street1: values.Address,
                                                street2: values.Address2,
                                                // partyCharacteristic: values.attributeList,
                                                adminOperator: {
                                                    userName: values.username,
                                                    email: values.email,
                                                    profile: {
                                                        firstName: values.firstname,
                                                        lastName: values.lastname,
                                                    },
                                                    dialCode: dialCodeWithoutSpaces,
                                                    phone: mobileNumberWithoutSpaces,
                                                    isSSOUser: rbac === "Keycloak" ? false : isSSOEnabled,
                                                    rbac: switchState.IdentityProvider === "Keycloak" ? rbac : switchState.IdentityProvider,
                                                },
                                                ...(isEdit ? { status: values.Status?.value } : {}),
                                            };
                                            if (!isEdit) {
                                                dispatch(
                                                    createOperator(
                                                        formattedValues,
                                                        setLoading,
                                                        navigate,
                                                        logoFile,
                                                        switchState,
                                                        true,
                                                        defaultConfigurations,
                                                        values.Domain.label,
                                                        isNonGeneric
                                                    )
                                                );
                                            } else {
                                                dispatch(
                                                    editOperator(
                                                        formattedValues,
                                                        operatorId,
                                                        setLoading,
                                                        navigate,
                                                        profile,
                                                        update,
                                                        setUpdate,
                                                        fileSelected,
                                                        logoFile,
                                                        editData,
                                                        setFileSelected,
                                                        setEditData,
                                                        switchState,
                                                        configData,
                                                        defaultConfigurations
                                                    )
                                                );
                                            }
                                            // }
                                        }}
                                    >
                                        <i className="ri-save-line label-icon align-middle fs-16 me-1"></i>
                                        Save
                                    </Button>
                                </div>
                            )}
                        </div>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}